import { render, staticRenderFns } from "./slowSqlLogs.vue?vue&type=template&id=482a2116"
import script from "./slowSqlLogs.vue?vue&type=script&lang=js"
export * from "./slowSqlLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482a2116')) {
      api.createRecord('482a2116', component.options)
    } else {
      api.reload('482a2116', component.options)
    }
    module.hot.accept("./slowSqlLogs.vue?vue&type=template&id=482a2116", function () {
      api.rerender('482a2116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/slowSqlLogs.vue"
export default component.exports